import { render, staticRenderFns } from "./EditSeo.vue?vue&type=template&id=115cf494&"
import script from "./EditSeo.vue?vue&type=script&lang=js&"
export * from "./EditSeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('115cf494')) {
      api.createRecord('115cf494', component.options)
    } else {
      api.reload('115cf494', component.options)
    }
    module.hot.accept("./EditSeo.vue?vue&type=template&id=115cf494&", function () {
      api.rerender('115cf494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/SiteBuilder/components/EditSeo.vue"
export default component.exports